<template>
  <main-template :header="header" :is-loading="isLoading">
    <div class="container-fluid container">
      <h1>Term of Use</h1>
      <div v-html="termAndCondition"></div>
    </div>
  </main-template>
</template>

<script>
import { get } from 'lodash'
import { COVER_IMG_TYPE, HERO_TEXT_CONFIG_KEY, SERVICE_KEY } from '@/configs/constants'
import { delay } from '@/helpers'
import ConfigApi from '@/api/config-api'
import MainTemplate from '@/templates/MainTemplate'

export default {
  name: 'TermOfUse',
  components: { MainTemplate },
  data () {
    return {
      termAndCondition: '',
      isLoading: false,
      header: {
        className: '',
        style: '',
        imgPath: '',
        isShow: true,
        resizeLogo: true,
        heroText: {
          headline: '',
          subHeadline: ''
        }
      }
    }
  },
  computed: {
    prefetchItems () {
      return this.$store.state.prefetchItems
    }
  },
  async serverPrefetch () {
    await this.preparePrefetchItems(true)
  },
  async created () {
    try {
      this.isLoading = true
      await this.preparePrefetchItems(false)
      await delay(300)
      this.isLoading = false
    } catch (err) {
      // console.log(err)
    }
  },
  methods: {
    async preparePrefetchItems (isServerPrefetch) {
      let prefetchItems = this.prefetchItems
      if (prefetchItems === null) {
        const promises = [
          ConfigApi.coverImgUrl(COVER_IMG_TYPE.TERM_AND_CONDITION),
          ConfigApi.configByKey(SERVICE_KEY.TERM_AND_CONDITION),
          ConfigApi.configByKey(HERO_TEXT_CONFIG_KEY.TERM_AND_CONDITION)
        ]

        const result = await Promise.all(promises)

        const coverImg = result[0]
        const termAndCondition = get(result[1], 'configValue', '')
        const heroTextConfig = result[2]
        const heroTextValue = get(heroTextConfig, 'configValue', '{}')
        const heroText = JSON.parse(heroTextValue)

        const header = {
          className: '',
          style: '',
          imgPath: coverImg.url,
          isShow: true,
          resizeLogo: true,
          heroText: heroText
        }
        prefetchItems = {
          header,
          termAndCondition
        }
      }

      if (isServerPrefetch) {
        this.$store.dispatch('initPrefetchItems', prefetchItems)
      } else {
        Object.assign(this, prefetchItems)

        this.$store.dispatch('clearPrefetchItems')
      }
    }
  }
}
</script>

<style scoped>

</style>
